import { v4 as uuidv4 } from 'uuid';
import {
	isLocalMediaItem,
	normalizeUploadedFileItem,
	pickFilesizeByte,
	pickFilesizeLabel,
} from './mediaItem.js';

/** 为 false 时走 uploadMediaToQiniu 真实上传 */
export const USE_LOCAL_FILE_MOCK = false;

export const MAX_LOCAL_FILES = 20;
export const MAX_LOCAL_FILE_SIZE = 50 * 1024 * 1024;

const IMAGE_EXT = /\.(jpe?g|png|gif|webp|bmp|svg)$/i;

export function formatFileSize(bytes) {
	if (!bytes || bytes <= 0) return '0 B';
	const units = ['B', 'KB', 'MB', 'GB'];
	let index = 0;
	let size = bytes;
	while (size >= 1024 && index < units.length - 1) {
		size /= 1024;
		index += 1;
	}
	const digits = index === 0 ? 0 : 2;
	return `${size.toFixed(digits)} ${units[index]}`;
}

export function isLocalImageFile(filename = '') {
	return IMAGE_EXT.test(filename);
}

export function createLocalFileItem(file) {
	const filename = file.name || '';
	const isImage = isLocalImageFile(filename);
	return {
		id: uuidv4(),
		filename,
		filesize: formatFileSize(file.size),
		filesize_byte: file.size,
		previewUrl: isImage ? URL.createObjectURL(file) : '',
		url: '',
		local: true,
	};
}

export function getLocalFileIcon(item = {}) {
	if (item.previewUrl && isLocalImageFile(item.filename)) {
		return item.previewUrl;
	}
	return '/img/file.png';
}

export function revokeLocalFileItem(item) {
	if (item?.previewUrl?.startsWith('blob:')) {
		URL.revokeObjectURL(item.previewUrl);
	}
}

export function revokeLocalFiles(items = []) {
	items.forEach(revokeLocalFileItem);
}

export function filterValidLocalFileList(files = [], maxCount = MAX_LOCAL_FILES) {
	const valid = [];
	for (const file of files) {
		if (!file) continue;
		if (file.size > MAX_LOCAL_FILE_SIZE) continue;
		valid.push(file);
		if (valid.length >= maxCount) break;
	}
	return valid;
}

export function normalizeLocalFileItem(item = {}) {
	if (!isLocalMediaItem(item)) {
		return normalizeUploadedFileItem(item);
	}
	return {
		id: item.id || uuidv4(),
		filename: item.filename || '',
		filesize: pickFilesizeLabel(item),
		filesize_byte: pickFilesizeByte(item),
		previewUrl: item.previewUrl || '',
		url: '',
		local: true,
	};
}

export function normalizeLocalFiles(items = []) {
	return items.map(normalizeLocalFileItem);
}

/** 1 允许下载，2 关闭下载 */
export const FILE_DOWNLOAD_ALLOW = 1;
export const FILE_DOWNLOAD_DENY = 2;
/** 0 未设置独立项，沿用全局 */
export const FILE_DOWNLOAD_INDEPENDENT_NONE = 0;

export function createDefaultFileDownloadSettings() {
	return {
		global: FILE_DOWNLOAD_ALLOW,
		independent: FILE_DOWNLOAD_INDEPENDENT_NONE,
	};
}

export function normalizeFileDownloadSettings(settings = {}) {
	const global = settings.global === FILE_DOWNLOAD_DENY
		? FILE_DOWNLOAD_DENY
		: FILE_DOWNLOAD_ALLOW;
	const independent = settings.independent === FILE_DOWNLOAD_ALLOW
		|| settings.independent === FILE_DOWNLOAD_DENY
		? settings.independent
		: FILE_DOWNLOAD_INDEPENDENT_NONE;
	return { global, independent };
}

/** 独立设置优先，未设置时使用全局 */
export function getEffectiveFileDownload(settings = {}) {
	const normalized = normalizeFileDownloadSettings(settings);
	if (normalized.independent === FILE_DOWNLOAD_ALLOW || normalized.independent === FILE_DOWNLOAD_DENY) {
		return normalized.independent;
	}
	return normalized.global;
}

export function normalizeHeaderFiles(data = {}) {
	return {
		items: normalizeLocalFiles(data.items),
		downloadSettings: normalizeFileDownloadSettings(data.downloadSettings),
	};
}
